"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBroadcastNotificationListDto = instanceOfBroadcastNotificationListDto;
exports.BroadcastNotificationListDtoFromJSON = BroadcastNotificationListDtoFromJSON;
exports.BroadcastNotificationListDtoFromJSONTyped = BroadcastNotificationListDtoFromJSONTyped;
exports.BroadcastNotificationListDtoToJSON = BroadcastNotificationListDtoToJSON;
exports.BroadcastNotificationListDtoToJSONTyped = BroadcastNotificationListDtoToJSONTyped;
var BroadcastNotificationDto_1 = require("./BroadcastNotificationDto");
/**
 * Check if a given object implements the BroadcastNotificationListDto interface.
 */
function instanceOfBroadcastNotificationListDto(value) {
    if (!('broadcasts' in value) || value['broadcasts'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    if (!('pageNo' in value) || value['pageNo'] === undefined)
        return false;
    if (!('pageSize' in value) || value['pageSize'] === undefined)
        return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined)
        return false;
    return true;
}
function BroadcastNotificationListDtoFromJSON(json) {
    return BroadcastNotificationListDtoFromJSONTyped(json, false);
}
function BroadcastNotificationListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'broadcasts': (json['broadcasts'].map(BroadcastNotificationDto_1.BroadcastNotificationDtoFromJSON)),
        'total': json['total'],
        'pageNo': json['pageNo'],
        'pageSize': json['pageSize'],
        'totalPages': json['totalPages'],
    };
}
function BroadcastNotificationListDtoToJSON(json) {
    return BroadcastNotificationListDtoToJSONTyped(json, false);
}
function BroadcastNotificationListDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'broadcasts': (value['broadcasts'].map(BroadcastNotificationDto_1.BroadcastNotificationDtoToJSON)),
        'total': value['total'],
        'pageNo': value['pageNo'],
        'pageSize': value['pageSize'],
        'totalPages': value['totalPages'],
    };
}
